; (function (inovestor, undefined) {
    // Setup dependencies for this plugin
    // Normally we would add jQuery and knockout but ms-core, which we depend on, already register them so it's useless

    // Create plugin namespace with any desired config variable
    inovestor.ms.etf = inovestor.ms.etf || {};
})(inovestor);


; (function (etf, undefined) {
    // Create plugin namespace with any desired config variable
    etf.summary = {
        config: {
            apiRelativeUrl: 'etfs/summary?symbol={symbol}',
        }
    };

})(inovestor.ms.etf);


; (function ($, ko, inovestor, undefined) {
    inovestor.ms.etf.summary.viewModels = {};

    inovestor.ms.etf.summary.viewModels.summaryViewModel = function (plugin) {
        var self = this;

        self.pdfReportUrl = plugin.options.pdfReportUrl;
        self.pdfHandler = plugin.options.pdfHandler;

        self.summary = ko.observable();
        self.resources = ko.observable();
        self.hasError = ko.observable(false);
        self.isInvalidIdentifier = ko.observable(false);
        self.hasValidData = ko.computed(function () {
            return !self.hasError() && !self.isInvalidIdentifier() && self.summary() != null;
        }, this);

        self.formattedLowHighWeeks = ko.computed(function () {
            var low = self.summary()?.low52Weeks;
            var high = self.summary()?.high52Weeks;

            if (low === null && high === null) {
                return '-';
            }
            return ko.bindingHandlers.currency.format(low, true, true, false, 2) + " - " + ko.bindingHandlers.currency.format(high, true, true, false, 2)
        });

        self.formattedDayRange = ko.computed(function () {
            var low = self.summary()?.low
            var high = self.summary()?.high

            if (low === null && high === null) {
                return '-'
            }

            return ko.bindingHandlers.currency.format(low, true, true, false, 2) + " - " + ko.bindingHandlers.currency.format(high, true, true, false, 2)
        })
        self.formattedBidAsk = ko.computed(function () {
            var bid = self.summary()?.bid
            var ask = self.summary()?.ask

            if (bid === null && ask === null) {
                return '-'
            }

            return ko.bindingHandlers.currency.format(bid, true, true, false, 2) + " - " + ko.bindingHandlers.currency.format(ask, true, true, false, 2)
        })
        self.formattedVolume = ko.computed(function () {
            var volume = self.summary()?.volume
            var avgVolume = self.summary()?.averageVolume30Days

            if (volume === null && avgVolume === null) {
                return '-'
            }
            
            return ko.bindingHandlers.number.format(volume, true, 2, true, 1, true) + " / " + ko.bindingHandlers.number.format(avgVolume, true, 2, true, 1, true)
        })

        self.updateResources = function () {
            // Update main resources
            var currentResource = inovestor.ms.etf.summary.resources[inovestor.ms.core.currentLanguage];
            if (inovestor.ms.core.isNullOrUndefined(currentResource))
                currentResource = null;
            self.resources(currentResource);
        };

        self.downloadPdf = function () {

        };
    }

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function ($, ko, inovestor, undefined) {

    var pluginName = 'inoMsEtfSummary';

    // Create the plugin constructor
    function Plugin(element, options) {

        this.element = element;
        this._name = pluginName;
        this._defaults = $.fn.inoMsEtfSummary.defaults;
        
        // Merge options with defaults
        this.options = $.extend({}, this._defaults, options);

        this._viewModel = new inovestor.ms.etf.summary.viewModels.summaryViewModel(this);

        // Make sure required variables are set
        if (inovestor.ms.core.isNullOrUndefined(this.options.symbol))
            throw "symbol is required";

        // Call init
        this.init();
    }

    $.extend(Plugin.prototype, {

        // Initialization logic
        init: function () {
            var plugin = this;

            // Setup what plugin needs to do on language change
            inovestor.ms.core.instances.register(this, function () {
                plugin.update();
            });

            // Plugin overrides for template = cacheKey and path are the same
            var fileCacheKey = plugin.options.templatePaths.summary;
            var filePath = plugin.options.templatePaths.summary;
            // Default behavior (if no template path is set by plugin)
            if (inovestor.ms.core.isEmptyString(fileCacheKey)) {
                var fileName = 'summary.html';
                fileCacheKey = pluginName + '.' + fileName;
                filePath = (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) ? '' : inovestor.ms.core.config.templateRootUrl) +
                    (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) || inovestor.ms.core.config.templateRootUrl.match(/\/$/) != null ? '' : '/') + // check if templateRootUrl ends in slash
                    (this._name + '/' + fileName);
            }

            // Get main template file
            inovestor.ms.core.getTemplate(fileCacheKey, filePath).then(function (template) {
                $(plugin.element).html(template);
                plugin.buildCache();
                plugin.bindEvents();
                plugin.render();
                plugin.bindModel();
            }).then(function () {
                // Call Search
                plugin.search(plugin.options.symbol).always(function () {
                    // When search is completed, trigger onReady event
                    plugin.$element.trigger('ready' + '.' + plugin._name);
                });
            });
        },

        // Remove plugin instance completely
        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        // Cache DOM nodes for performance
        buildCache: function () {
            this.$element = $(this.element);
        },

        // Bind events that trigger methods
        bindEvents: function () {
            var plugin = this;
            plugin.$element.on('ready' + '.' + plugin._name, function () {
                var onReady = plugin.options.onReady;
                if (typeof onReady === 'function')
                    onReady.call(plugin.$element);
            });
        },

        // Unbind events that trigger methods
        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        // API error handler
        apiErrorHandler: function (apiError) {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.apiError, apiError, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.hasError(true);
        },

        // Invalid Identifier error handler
        invalidIdentifierHandler: function () {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.invalidIdentifier, null, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.isInvalidIdentifier(true);
        },

        // Search for a particular etf
        search: function (symbol) {
            var plugin = this;

            // Make sure required variables are set
            if (inovestor.ms.core.isNullOrUndefined(symbol))
                throw "symbol is required";

            // Update options
            plugin.options.symbol = symbol;

            // Setup API url with term
            var etfSummaryUrl = inovestor.ms.core.stringFormat(inovestor.ms.etf.summary.config.apiRelativeUrl, { symbol: symbol });
            //var etfSummaryUrl = inovestor.ms.core.stringFormat(inovestor.ms.etf.summary.config.apiRelativeUrl, {});

            // Reset relevant Data before calling API
            plugin._viewModel.summary(null);
            plugin._viewModel.hasError(false);
            plugin._viewModel.isInvalidIdentifier(false);

            // Call API and bind model
            var options = { type: 'GET', contentType: 'application/json', error: function (error) { plugin.apiErrorHandler(error); } };
            return inovestor.ms.core.ajaxApi(etfSummaryUrl, options).then(function (data) {
                if (!inovestor.ms.core.isNullOrUndefined(data)) {
                    if (data.requestStatus === 'invalidIdentifier')
                        plugin.invalidIdentifierHandler();
                    plugin._viewModel.summary(data);

                }
                plugin.update();
            });
        },

        // Renders html template and binds model (should be called once)
        render: function () {
            var plugin = this;
            plugin._viewModel.updateResources();
        },

        // Update resources
        update: function () {
            var plugin = this;
            // Update view model resources
            plugin._viewModel.updateResources();
            plugin._viewModel.summary.valueHasMutated();
        },

        // Applies knockout bindings to element. (Should be done only once)
        bindModel: function () {
            var plugin = this;
            ko.applyBindings(plugin._viewModel, plugin.element);
        },
    });

    // JQuery Plugin wrapper
    $.fn.inoMsEtfSummary = function (options) {
        this.each(function () {
            if (!$.data(this, pluginName)) {
                // Store instance of plugin in "$.data"
                $.data(this, pluginName, new Plugin(this, options));
            }
        });

        // return plugin to support JQuery chaining
        return this;
    };

    // Default options for plugin
    $.fn.inoMsEtfSummary.defaults = {
        symbol: null,
        onError: null,
        onReady: null,
        pdfReportUrl: null,
        pdfHandler: null,
        templatePaths: {
            summary: null
        }
    };

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function (etf, undefined) {
    etf.summary.resources = etf.summary.resources || {};
    etf.summary.resources["en"] = {
        asOf: 'As of',
        assetClass: 'Asset Class',
        bidAsk: 'Bid / Ask',
        currency: 'Currency',
        totalAssetInfo: 'For this ETF Series only',
        dataDelayedBy: 'Data delayed by {minutes} minutes',
        dataRealTime: 'Real-time data',
        dayRange: "Day Range",
        dividend: "Dividend (yield)",
        earningsPerShareTTM: 'Earnings / Share',
        fiftyTwoWeek: "52-Week Range",
        previousClose: "Previous Close",
        riskRating: "Risk Rating",
        volume: "Vol / Avg",
        category: 'Category',
        managementFeesRatio: "MER",
        managementFees: "Management Fees",
        aum: 'AUM',
        ranking: "Ranking",
        inceptionDate: "Inception Date",
        open: "Open",
        totalAssests: "Total Assets",
        currentYield: "Current Yield",
        unitsOutstanding: "Units Outstanding",
        distributionYield: "Distribution\r\nYield&nbsp;(TTM)",
        distributionYieldInfo: "TTM Distribution Yield refers to trailing twelve months distribution divided by the previous day close.",
        downloadPdf: "DOWNLOAD PDF",
        riskRatings: {
            low: 'Low',
            lowToMedium: 'Low to Medium',
            medium: 'Medium',
            mediumToHigh: 'Medium to High',
            high: 'High',
            null: '-'
        }
    };
})(inovestor.ms.etf);

; (function (etf, undefined) {
    etf.summary.resources = etf.summary.resources || {};
    etf.summary.resources["fr"] = {
        asOf: 'Au',
        assetClass: 'Classe d\'actifs',
        bidAsk: 'Cours achet. / Cours vend.',
        currency: 'Devise',
        totalAssetInfo: 'Pour cette série de FNB seulement',
        dataDelayedBy: 'Données différées de {minutes} minutes',
        dataRealTime: 'Données en temps réel',
        dayRange: "Var. jour",
        dividend: "Dividende (rendement)",
        earningsPerShareTTM: 'Bénéfice par action',
        fiftyTwoWeek: "Var. 52 semaines",
        previousClose: "Clôture",
        riskRating: "Cote de risque",
        volume: "Vol / Moy.",
        category: "Catégorie",
        managementFeesRatio: "RFG",
        managementFees: "Frais de gestion",
        aum: 'Actifs sous gestion',
        ranking: "Classement",
        inceptionDate: "Date de création",
        open: "Ouverture",
        totalAssests: "Actifs",
        currentYield: "Revenu actuel",
        unitsOutstanding: "Parts en circulation",
        distributionYield: "Revenu de distribution&nbsp;(DDM)",
        distributionYieldInfo: "Rendement des distributions sur 12 mois (TTM) fait référence à la distribution des douze derniers mois, divisée par la clôture de la veille.",
        downloadPdf: "TÉLÉCHARGER PDF",
        riskRatings: {
            low: 'Faible',
            lowToMedium: 'Faible à moyen',
            medium: 'Moyen',
            mediumToHigh: 'Moyen à élevé',
            high: 'Élevé',
            null: '-'
        }
    };
})(inovestor.ms.etf);